(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-rail"] && !Shopify.designMode) return;
  try {
    
  class CategoryRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.category-rail__track');
      if (!this.track || !this.hasAttribute('data-autoplay')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.speed = parseInt(this.getAttribute('data-speed'), 10) || 3200;
      this.paused = false;

      const pause = () => { this.paused = true; };
      const resume = () => { this.paused = false; };
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', resume);
      this.addEventListener('touchstart', pause, { passive: true });
      this.addEventListener('touchend', resume, { passive: true });
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);

      this.timer = setInterval(() => this.advance(), this.speed);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    advance() {
      if (this.paused) return;
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step, behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('category-rail')) {
    customElements.define('category-rail', CategoryRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.__mdmFavHeart) {
    window.__mdmFavHeart = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.pcard__heart');
      if (!btn) return;
      e.preventDefault();
      btn.classList.toggle('is-on');
      btn.setAttribute('aria-pressed', btn.classList.contains('is-on'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-builder"] && !Shopify.designMode) return;
  try {
    
  class PackBuilder extends HTMLElement {
    connectedCallback() {
      this.items = new Map(); // variantId -> { qty, price, title, variant, img }
      this.currency = this.dataset.currency || 'EUR';
      this.minItems = parseInt(this.dataset.minItems, 10) || 0;
      this.ctaLabel = this.dataset.ctaLabel || 'Ajouter au panier';
      this.fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: this.currency });

      this.itemsEl = this.querySelector('[data-items]');
      this.placeholderEl = this.querySelector('[data-placeholder]');
      this.totalEl = this.querySelector('[data-total]');
      this.checkoutBtn = this.querySelector('[data-checkout]');
      this.errorEl = this.querySelector('[data-error]');
      this.codeNoteEl = this.querySelector('[data-code-note]');

      // Mise à jour du prix affiché d'une carte au changement de variante
      this.addEventListener('change', (e) => {
        const sel = e.target.closest('[data-variant]');
        if (!sel || sel.tagName !== 'SELECT') return;
        const card = sel.closest('.pb-card');
        const opt = sel.options[sel.selectedIndex];
        const priceEl = card.querySelector('[data-card-price]');
        if (priceEl && opt) priceEl.textContent = this.money(parseInt(opt.dataset.price, 10));
        const img = card.querySelector('.pb-card__img');
        if (img && opt && opt.dataset.img) {
          img.removeAttribute('srcset');
          img.src = opt.dataset.img;
        }
      });

      this.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-add]');
        if (addBtn) { this.addFromCard(addBtn); return; }
        const minus = e.target.closest('[data-minus]');
        if (minus) { this.changeQty(minus.dataset.minus, -1); return; }
        const plus = e.target.closest('[data-plus]');
        if (plus) { this.changeQty(plus.dataset.plus, 1); return; }
        const rm = e.target.closest('[data-remove]');
        if (rm) { this.remove(rm.dataset.remove); return; }
        const checkout = e.target.closest('[data-checkout]');
        if (checkout) { this.submit(); return; }
      });

      // Pré-remplissage depuis l'URL (« Personnaliser un pack ») + code promo éventuel.
      const params = new URLSearchParams(location.search);
      this.discountCode = (params.get('discount') || '').trim();
      const seed = params.get('seed');
      if (seed) {
        seed.split(',').map((s) => s.trim()).filter(Boolean).forEach((vid) => {
          const card = this.findCardByVariant(vid);
          if (card) this.addCardVariant(card, vid);
        });
      }
    }

    money(cents) { return this.fmt.format((cents || 0) / 100); }

    findCardByVariant(variantId) {
      const vid = String(variantId);
      return [...this.querySelectorAll('.pb-card')].find((card) => {
        const el = card.querySelector('[data-variant]');
        if (!el) return false;
        if (el.tagName === 'SELECT') return [...el.options].some((o) => o.value === vid);
        return el.value === vid;
      }) || null;
    }

    addFromCard(btn) { this.addCardVariant(btn.closest('.pb-card'), null); }

    // Ajoute la variante d'une carte au pack. forcedId = variante précise (seed) ; sinon variante sélectionnée.
    // Ne masque jamais la carte : recliquer incrémente la quantité.
    addCardVariant(card, forcedId) {
      if (!card) return;
      const variantEl = card.querySelector('[data-variant]');
      if (!variantEl) return;
      let id, price, variantTitle;
      if (variantEl.tagName === 'SELECT') {
        let opt = null;
        if (forcedId) opt = [...variantEl.options].find((o) => o.value === String(forcedId) && !o.disabled);
        if (!opt) opt = variantEl.options[variantEl.selectedIndex];
        if (!opt || opt.disabled) return;
        if (variantEl.value !== opt.value) {
          variantEl.value = opt.value;
          const priceEl = card.querySelector('[data-card-price]');
          if (priceEl) priceEl.textContent = this.money(parseInt(opt.dataset.price, 10));
          const img = card.querySelector('.pb-card__img');
          if (img && opt.dataset.img) { img.removeAttribute('srcset'); img.src = opt.dataset.img; }
        }
        id = opt.value;
        price = parseInt(opt.dataset.price, 10);
        variantTitle = opt.dataset.vtitle || '';
      } else {
        id = variantEl.value;
        price = parseInt(variantEl.dataset.price, 10);
        variantTitle = '';
      }
      if (!id) return;
      const existing = this.items.get(id);
      if (existing) {
        existing.qty += 1;
      } else {
        const btn = card.querySelector('[data-add]');
        const titleEl = card.querySelector('.pb-card__title');
        this.items.set(id, {
          qty: 1,
          price: price,
          title: (btn && btn.dataset.title) || (titleEl && titleEl.textContent.trim()) || '',
          variant: variantTitle,
          img: (btn && btn.dataset.img) || '',
        });
      }
      this.render();
    }

    changeQty(id, delta) {
      const it = this.items.get(id);
      if (!it) return;
      it.qty += delta;
      if (it.qty <= 0) this.items.delete(id);
      this.render();
    }

    remove(id) { this.items.delete(id); this.render(); }

    render() {
      this.itemsEl.innerHTML = '';
      let total = 0;
      let count = 0;
      this.items.forEach((it, id) => {
        total += it.price * it.qty;
        count += it.qty;
        const li = document.createElement('li');
        li.className = 'pb-item';
        const variantLine = it.variant ? `<span class="pb-item__variant">${this.esc(it.variant)}</span>` : '';
        const imgTag = it.img
          ? `<img class="pb-item__img" src="${it.img}" alt="" width="44" height="44" loading="lazy">`
          : `<span class="pb-item__img"></span>`;
        li.innerHTML =
          imgTag +
          `<div class="pb-item__info">` +
            `<span class="pb-item__name">${this.esc(it.title)}</span>` +
            variantLine +
            `<span class="pb-item__controls">` +
              `<button type="button" class="pb-item__qbtn" data-minus="${id}" aria-label="Diminuer">−</button>` +
              `<span class="pb-item__qty">${it.qty}</span>` +
              `<button type="button" class="pb-item__qbtn" data-plus="${id}" aria-label="Augmenter">+</button>` +
            `</span>` +
          `</div>` +
          `<div class="pb-item__right">` +
            `<button type="button" class="pb-item__remove" data-remove="${id}" aria-label="Retirer">×</button>` +
            `<span class="pb-item__subtotal">${this.money(it.price * it.qty)}</span>` +
          `</div>`;
        this.itemsEl.appendChild(li);
      });
      this.totalEl.textContent = this.money(total);
      this.placeholderEl.hidden = this.items.size > 0;
      this.checkoutBtn.disabled = count < Math.max(1, this.minItems);
      this.errorEl.hidden = true;
      if (this.codeNoteEl) {
        const label = this.codeNoteEl.dataset.label || '';
        const show = !!this.discountCode && count > 0 && label !== '';
        this.codeNoteEl.textContent = show ? label : '';
        this.codeNoteEl.hidden = !show;
      }
    }

    esc(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    submit() {
      if (this.items.size === 0) return;
      const cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const packId = 'pack-' + Date.now().toString(36);
      const items = [];
      this.items.forEach((it, id) => {
        items.push({
          id: Number(id),
          quantity: it.qty,
          properties: { _pack: 'composer', _pack_id: packId },
        });
      });

      this.checkoutBtn.disabled = true;
      this.checkoutBtn.textContent = 'Ajout…';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status) {
            this.showError(data.description || data.message || 'Une erreur est survenue.');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'pack-builder', data: { source: 'pack-builder' } },
          }));
          window.location.href = this.discountCode
            ? '/discount/' + encodeURIComponent(this.discountCode) + '?redirect=/cart'
            : ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart');
        })
        .catch(() => this.showError('Connexion impossible. Réessayez.'));
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      this.checkoutBtn.disabled = false;
      this.checkoutBtn.textContent = this.ctaLabel;
    }
  }

  if (!customElements.get('pack-builder')) {
    customElements.define('pack-builder', PackBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["packs-section"] && !Shopify.designMode) return;
  try {
    
  class PackBuy extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-buy]');
      if (this.btn) this.btn.addEventListener('click', () => this.buy());
    }
    buy() {
      const ids = (this.dataset.variants || '').split(',').map((s) => s.trim()).filter(Boolean);
      if (!ids.length) return;
      const cartAddUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const packId = 'pack-' + (this.dataset.handle || 'x') + '-' + Date.now().toString(36);
      const items = ids.map((id) => ({
        id: Number(id),
        quantity: 1,
        properties: { _pack: 'preset', _pack_id: packId },
      }));
      const orig = this.btn.textContent;
      this.btn.disabled = true;
      this.btn.textContent = 'Ajout…';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status) {
            this.btn.disabled = false;
            this.btn.textContent = orig;
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { source: 'pack-buy', data: { source: 'pack-buy' } },
          }));
          const code = (this.dataset.code || '').trim();
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
            : '/checkout';
        })
        .catch(() => {
          this.btn.disabled = false;
          this.btn.textContent = orig;
        });
    }
  }
  if (!customElements.get('pack-buy')) {
    customElements.define('pack-buy', PackBuy);
  }

  } catch(e) { console.error(e); }
})();
})();
